// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { SubscriptionRoutes } from "..";
import styled from "@emotion/styled";
import { filter, pipe } from "callbag-basics";
import subscribe from "callbag-subscribe";
import { noop } from "lodash";
import { Component } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Dispatch } from "redux";

import { SpacingToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { isExpired, isSubscribed } from "helpers/subscription";
import { getDefaultSummaryInfo, getSummaryInfo, isUpsell } from "helpers/subscription-features";
import { onSubscriptionUpgradeFailed } from "hooks/use-payment-failure";
import { IStoreState } from "interfaces/storeState";
import { StyledWrapper } from "routes/subscription/SubscriptionPlans/styled";
import { actions$ } from "store/action-stream";
import { selectStandardPlansLimits } from "store/entities/application-settings/selectors";
import { IBilling } from "store/entities/billing";
import { selectContactFormsCount } from "store/entities/contact-forms/selectors";
import { selectActiveCustomFieldsList } from "store/entities/custom-fields/selectors";
import { selectCustomEmailDomains } from "store/entities/email-domains";
import { selectEmailTemplatesList } from "store/entities/email-template/selectors";
import { IMacro } from "store/entities/macros/interfaces";
import { selectMailboxesCount } from "store/entities/mailboxes/selectors";
import { getRecurlyActiveCoupon, getRecurlyNewCoupon } from "store/entities/recurly";
import { selectReplyAddressesAlphabetically } from "store/entities/reply-addresses/selectors";
import { selectActiveRules } from "store/entities/rules/selectors";
import {
  BillingCycle,
  ISubscription,
  Plan,
  SUBSCRIPTION,
  SubscriptionActions,
  selectIsUpdatingSubscription,
} from "store/entities/subscriptions";
import { selectTeamsCount } from "store/entities/teams";
import { IAction } from "store/helper";
import { withVar } from "themes/helpers";

import { BlackFridayBanner2024 } from "../components/BlackFridayBanner2024";

import { SubscriptionPlansEnterprise } from "./SubscriptionPlansEnterprise";
import { SubscriptionPlansFeatures } from "./SubscriptionPlansFeatures";
import { CurrentPlanDetails } from "./current-plan-details";
import { PlanSummary } from "./plan-summary/PlanSummary";
import { PlansTiles } from "./plan-tiles";
import { getRecommendedPlanBasedOnUsage } from "./plan-tiles/helpers";

interface ISubscriptionData {
  plan: Plan;
  agents: number;
  billingCycle: BillingCycle;
}

interface IOwnProps {
  macros: IMacro[];
  subscription: ISubscription | null;
  newSubscription: ISubscription;
  teamsCount: number;
  nonViewersCount: number;
  billing: IBilling | null;
  onPlanChange(plan: Plan): void;
  onBillingCycleChange(billingCycle: BillingCycle): void;
  onSeatsChange(seats: number): void;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: IStoreState) => ({
  teamsCount: selectTeamsCount(state),
  mailboxesCount: selectMailboxesCount(state),
  contactFormsCount: selectContactFormsCount(state),
  isSavingSubscription: selectIsUpdatingSubscription(state),
  newCoupon: getRecurlyNewCoupon(state),
  coupon: getRecurlyActiveCoupon(state),
  replyAddresses: selectReplyAddressesAlphabetically(state),
  fullyCustomDomains: selectCustomEmailDomains(state),
  // @ts-expect-error TS(2345)
  emailTemplates: selectEmailTemplatesList(state),
  activeWorkflows: selectActiveRules(state),
  activeCustomFields: selectActiveCustomFieldsList(state),
  planLimits: selectStandardPlansLimits(state),
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch) => ({
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onSubscriptionSave: (subscription: ISubscriptionData) =>
    // @ts-expect-error TS(2345)
    dispatch(SubscriptionActions.update({ value: subscription })),
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
interface IProps extends IOwnProps, StateProps, DispatchProps, RouteComponentProps {}

const salesContactFormLink = "https://www.helpdesk.com/sales-contact-form/";

export class SubscriptionPlans extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
    this.unsubscribeUpdateFailure = (): void => {};
    this.unsubscribeUpdateSuccess = (): void => {};
  }

  static defaultProps = {
    mailboxesCount: 0,
    contactFormsCount: 0,
    isSavingSubscription: false,
    newCoupon: null,
    coupon: null,
    onSubscriptionSave: noop,
  };

  private unsubscribeUpdateFailure: () => void;
  private unsubscribeUpdateSuccess: () => void;

  private recommendedPlan = getRecommendedPlanBasedOnUsage({
    teamsCount: this.props.teamsCount,
    forwardingAddressesCount: this.props.mailboxesCount,
    replyAddressesCount: this.props.replyAddresses.length,
    fullyCustomDomainsCount: this.props.fullyCustomDomains.length,
    emailTemplatesCount: this.props.emailTemplates.length,
    activeWorkflowsCount: this.props.activeWorkflows.length,
    activeCustomFieldsCount: this.props.activeCustomFields.length,
    sharedMacrosCount: this.props.macros.filter(macro => macro.agentId === null).length,
    standardPlansLimits: this.props.planLimits,
  });

  state = {
    isModalOpen: false,
    paymentFailed: false,
  };

  componentDidMount(): void {
    trackEngagement("Your subscription: Section opened", EventPlace.Invoices);
    this.unsubscribeUpdateFailure = onSubscriptionUpgradeFailed(() => this.setState({ paymentFailed: true }));
    this.unsubscribeUpdateSuccess = pipe(
      actions$,
      filter(
        (action: IAction) => action.type === SUBSCRIPTION.UPDATE.SUCCESS || action.type === SUBSCRIPTION.CREATE.FAILURE
      ),
      subscribe(() => this.props.history.push(SubscriptionRoutes.ThankYou))
    );

    const { billing, onPlanChange, subscription } = this.props;
    const hasCreditCard = !!billing?.billingInfo;
    if (!hasCreditCard && subscription && !isUpsell(this.recommendedPlan, subscription.plan)) {
      onPlanChange(this.recommendedPlan);
    }
  }

  componentWillUnmount(): void {
    if (this.unsubscribeUpdateFailure) {
      this.unsubscribeUpdateFailure();
    }
    if (this.unsubscribeUpdateSuccess) {
      this.unsubscribeUpdateSuccess();
    }
  }

  componentDidUpdate(prevProps: IProps): void {
    if (prevProps.newSubscription.agents > this.props.newSubscription.agents) {
      this.setState({ paymentFailed: false });
    }
  }

  handleSubscriptionSave = (): void => {
    const { subscription, newSubscription, billing, onSubscriptionSave, history } = this.props;
    const hasSubscription = isSubscribed(billing) && !isExpired(subscription);

    if (hasSubscription) {
      onSubscriptionSave(newSubscription as ISubscriptionData);
      this.handleCloseModal();
    } else {
      history.push(SubscriptionRoutes.Card);
    }
  };

  handleOpenModal = (): void => this.setState({ isModalOpen: true });

  handleCloseModal = (): void => {
    trackEngagement("Keep my plan cta clicked", EventPlace.Subscription);
    this.setState({ isModalOpen: false });
  };

  handleConfirmModal = (): void => {
    trackEngagement("I still want to downgrade cta clicked", EventPlace.Subscription);
    this.handleSubscriptionSave();
  };

  handleEnterpriseContactUs = (): void => {
    window.open(salesContactFormLink, "_blank");
  };

  render(): JSX.Element {
    const {
      subscription,
      newSubscription,
      nonViewersCount,
      billing,
      newCoupon,
      coupon: currentCoupon,
      onPlanChange,
      onBillingCycleChange,
      onSeatsChange,
      isSavingSubscription,
    } = this.props;
    const coupon = newCoupon || currentCoupon;

    const hasCreditCard = !!billing?.billingInfo;

    const features = subscription
      ? hasCreditCard
        ? getSummaryInfo(newSubscription.plan, subscription.plan, null)
        : getSummaryInfo(newSubscription.plan, subscription.plan, this.recommendedPlan)
      : getDefaultSummaryInfo();

    const isPlanDowngraded = subscription
      ? hasCreditCard
        ? !isUpsell(newSubscription.plan, subscription.plan)
        : !isUpsell(newSubscription.plan, subscription.plan) && !isUpsell(newSubscription.plan, this.recommendedPlan)
      : false;

    const isSamePlan = subscription ? newSubscription.plan === subscription.plan : false;

    return (
      <StyledWrapper>
        <BlackFridayBanner2024 />
        <CurrentPlanDetails />
        <PlansTiles
          // @ts-expect-error TS(2322)
          subscription={subscription}
          newSubscription={newSubscription}
          billing={billing}
          recommendedPlan={this.recommendedPlan}
          nonViewersCount={nonViewersCount}
          onPlanChange={onPlanChange}
        />
        <PlanInformationWrapper>
          <SubscriptionPlansFeatures
            selectedPlan={newSubscription?.plan}
            currentPlan={subscription?.plan}
            features={features}
            downgrade={isPlanDowngraded}
            isSamePlan={isSamePlan}
          />
          {newSubscription.plan === Plan.Enterprise && subscription?.plan !== Plan.Enterprise ? (
            <SubscriptionPlansEnterprise onCtaClick={this.handleEnterpriseContactUs} />
          ) : (
            <PlanSummary
              newSubscription={newSubscription}
              coupon={coupon || null}
              nonViewersCount={nonViewersCount}
              isSavingSubscription={isSavingSubscription}
              onSubscriptionSave={this.handleSubscriptionSave}
              onBillingCycleChange={onBillingCycleChange}
              onSeatsChange={onSeatsChange}
              paymentFailed={this.state.paymentFailed}
            />
          )}
        </PlanInformationWrapper>
      </StyledWrapper>
    );
  }
}

const PlanInformationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${withVar(SpacingToken.Spacing8)} 0;

  @media (max-width: ${ResponsiveBreakpoint.Tablet}px) {
    flex-direction: column;
    gap: ${withVar(SpacingToken.Spacing8)};
  }
`;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlans));
